import React from "react";
import { Link } from "react-router-dom";
import { BiSolidCartAdd } from "react-icons/bi";
import { addToCart } from "../../redux/features/cartSlice";
import { useDispatch } from "react-redux";

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();

  const handleAddCart = (product) => {
    dispatch(addToCart(product));
  };
  return (
    <div
      className="w-72 bg-white shadow-md duration-500 hover:scale-105 hover:shadow-xl"
    >
      <img
        src={product.image}
        alt={product.name}
        className="h-80 w-72 object-cover"
      />
      <div className="px-4 py-3 w-72">
        <span className="text-gray-400 mr-3 uppercase text-xs">
          {product.category.name}
        </span>
        <p className="text-lg font-bold text-black truncate block capitalize">
          {product.name}
        </p>
        <div className="flex items-center">
          <p className="text-lg font-semibold text-black cursor-auto my-3">
            {product.price}
          </p>
          <del>
            <p className="text-sm text-gray-600 cursor-auto ml-2">
              {product.price}
            </p>
          </del>
        </div>
        <div className="flex justify-between ml-auto">
          <button>
            <Link to={`/product/${product.id}`}>Detail</Link>
          </button>
          <button>
            <BiSolidCartAdd size={30} onClick={() => handleAddCart(product)} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
